import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StandardVendorPortfolio from './StandardVendorPortfolio';
import GroceryStockDashboard from './GroceryStockDashboard';
import FastFoodRecords from './FastFoodRecords';

const normalizeMode = (value) => {
  const v = String(value || '').trim().toLowerCase();
  if (v === 'wholesale' || v === 'wholsale') return 'wholesale';
  return 'retail';
};

const VendorPortfolio = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const vendorId =
    queryParams.get('vendorId') ||
    localStorage.getItem('vendorId') ||
    localStorage.getItem('userId') ||
    '';

  const businessType = (
    queryParams.get('businessType') ||
    queryParams.get('vendorType') ||
    localStorage.getItem('businessType') ||
    localStorage.getItem('vendorType') ||
    'fastfood'
  )
    .toLowerCase()
    .trim();

  const groceryMode = normalizeMode(
    queryParams.get('groceryMode') ||
      queryParams.get('mode') ||
      localStorage.getItem('groceryMode') ||
      localStorage.getItem('mode') ||
      localStorage.getItem('grocery_dashboard_mode') ||
      'wholesale'
  );

  useEffect(() => {
    if (vendorId) {
      localStorage.setItem('vendorId', vendorId);
      localStorage.setItem('userId', vendorId);
    }

    if (businessType) {
      localStorage.setItem('businessType', businessType);
      localStorage.setItem('vendorType', businessType);
    }

    if (businessType === 'grocery') {
      localStorage.setItem('groceryMode', groceryMode);
      localStorage.setItem('mode', groceryMode);
      localStorage.setItem('grocery_dashboard_mode', groceryMode);
    }

    const params = new URLSearchParams(location.search);

    if (vendorId && !params.get('vendorId')) {
      params.set('vendorId', vendorId);
    }

    if (businessType === 'grocery') {
      params.set('businessType', 'grocery');
      params.set('vendorType', 'grocery');
      params.set('groceryMode', groceryMode);
      params.set('mode', groceryMode);
    }

    if (businessType === 'fastfood') {
      params.set('businessType', 'fastfood');
      params.set('vendorType', 'fastfood');
    }

    const nextUrl = `${location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', nextUrl);

    console.log('VendorPortfolio debug =>', {
      vendorId,
      businessType,
      groceryMode,
      search: location.search,
      localVendorId: localStorage.getItem('vendorId'),
      localUserId: localStorage.getItem('userId'),
      localBusinessType: localStorage.getItem('businessType'),
      localVendorType: localStorage.getItem('vendorType'),
      localGroceryMode: localStorage.getItem('groceryMode'),
      localMode: localStorage.getItem('mode'),
      localDashboardMode: localStorage.getItem('grocery_dashboard_mode'),
    });
  }, [vendorId, businessType, groceryMode, location.pathname, location.search]);

  if (businessType === 'fastfood') {
    return <FastFoodRecords vendorId={vendorId} />;
  }

  if (businessType === 'grocery') {
    return (
      <GroceryStockDashboard
        vendorId={vendorId}
        groceryMode={groceryMode}
      />
    );
  }

  return <StandardVendorPortfolio vendorId={vendorId} />;
};

export default VendorPortfolio;
